export const convertDateRangeToParams = dateRange => {
  const from = dateRange[0];
  const to = dateRange[dateRange.length - 1];
  const range = {
    from: from.getTime(),
    to: to.getTime(),
  };
  return range;
};

export const convertFullCalendarDateRangeToParams = dateRange => {
  const range = {
    from: dateRange.start.getTime(),
    to: dateRange.end.getTime(),
  };
  return range;
};
